import { asField } from 'informed';
import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import themes from '../../theming/themes.js';
import React, { useContext, useEffect } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import CheckboxBox from './_CheckboxBox.js';
import CheckboxButton from './_CheckboxButton.js';
import CheckboxContainer from './_CheckboxContainer.js';
import CheckboxLabel from './_CheckboxLabel.js';
import { CheckboxGroupContext } from './CheckboxGroup.js';

var _excluded = ["fieldApi", "fieldState"],
  _excluded2 = ["checked", "onChange", "onBlur", "initialValue", "forwardedRef", "theme", "title", "field", "hideLabel"];
var handleChange = function handleChange(setValue, onChange, parentOnChange, field, handleSelectAll) {
  return function (e) {
    setValue(e.target.checked);
    if (onChange) {
      onChange(e);
    }
    // new stuff
    handleSelectAll(e.target.checked);
    //   dont do the checkboxGroup stuff
    //   if (parentOnChange) {
    //     parentOnChange({ fieldName: field, value: e.target.checked });
    //   }
  };
};
var handleBlur = function handleBlur(setTouched, onBlur, parentOnBlur) {
  return function (e) {
    setTouched(true);
    if (onBlur) {
      onBlur(e);
    }
    //   dont do the checkboxGroup stuff
    //   if (parentOnBlur) {
    //     parentOnBlur(e);
    //   }
  };
};
// TODO: allow custom selectAll/deselectAll labels
// TODO: review props - trim/adjust/remove what isn't needed
var SelectAllCheckbox = function SelectAllCheckbox(_ref) {
  var fieldApi = _ref.fieldApi,
    fieldState = _ref.fieldState,
    props = _objectWithoutProperties(_ref, _excluded);
  var value = fieldState.value,
    error = fieldState.error;
  var setValue = fieldApi.setValue,
    setTouched = fieldApi.setTouched;
  var checked = props.checked,
    onChange = props.onChange,
    onBlur = props.onBlur,
    initialValue = props.initialValue,
    forwardedRef = props.forwardedRef,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? themes["default"] : _props$theme,
    title = props.title,
    field = props.field,
    hideLabel = props.hideLabel,
    rest = _objectWithoutProperties(props, _excluded2);
  var _useContext = useContext(CheckboxGroupContext),
    parentError = _useContext.error,
    parentOnChange = _useContext.onChange,
    parentOnBlur = _useContext.onBlur,
    handleSelectAll = _useContext.handleSelectAll,
    registerSelectAllCheckbox = _useContext.registerSelectAllCheckbox,
    deregisterSelectAllCheckbox = _useContext.deregisterSelectAllCheckbox;
  /*
   * Registers the checkBoxRef to the CheckboxGroup
   */
  useEffect(function () {
    if (registerSelectAllCheckbox) {
      registerSelectAllCheckbox(fieldApi);
    }
    return function () {
      if (deregisterSelectAllCheckbox) {
        deregisterSelectAllCheckbox(fieldApi);
      }
    };
  }, []);
  var label = value ? 'Deselect All' : 'Select All';
  return /*#__PURE__*/React.createElement(CheckboxContainer, {
    htmlFor: field,
    hideLabel: hideLabel
  }, /*#__PURE__*/React.createElement(CheckboxBox, _extends({}, rest, {
    checked: value || initialValue || false,
    id: field,
    error: error || parentError,
    theme: theme,
    type: 'checkbox',
    value: (value || initialValue || false).toString(),
    onChange: handleChange(setValue, onChange, parentOnChange, field, handleSelectAll),
    onBlur: handleBlur(setTouched, onBlur)
  })), /*#__PURE__*/React.createElement(CheckboxButton, {
    title: title,
    theme: theme,
    error: error || parentError
  }), /*#__PURE__*/React.createElement(CheckboxLabel, {
    "aria-label": label,
    hideLabel: hideLabel,
    title: title
  }, label));
};
var _SelectAllCheckbox = withDefaultTheme(
// @ts-ignore
asField(SelectAllCheckbox));

export default _SelectAllCheckbox;
